import React from 'react';
import { TextField, IconButton } from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import { Field, FieldArray, useField, useFormikContext } from 'formik';
import get from 'lodash/get';
import { FormikTextField } from '../../../shared/Formik/FormikTextField';
import { FormikFileField } from '../../../shared/Formik/FormikFileField';
import { Label, StyledField, ErrorText } from '../../CreateCampign.styles';
import { PollAnswerWrapper, AddAnswerButton, MediaDescription } from './Content.styles';

export const getBannerText = (type: string) => {
  switch (type) {
    case 'B':
      return <div>For best results of dislaying your <b>leaderboard</b>, please upload separate media for desktop and mobile.<br/></div>
    default:
      return;
  }
}

export const ContentFields = ({ type }: any) => {
  const [field, meta, helpers] = useField('content.poll.choices');
  const { errors, submitCount } = useFormikContext();
  if (type === 'P') {
    return (
      <>
        <Label>Media</Label>
        <Field
          name="content.mediaFile"
          component={FormikFileField}
          size="poll"
        />
        <MediaDescription>Only file types are suppoted: BMP, PNG, JPG. Maximum file size 25MB.</MediaDescription>
        <Label>Poll Question</Label>
        <Field
          name="content.poll.question"
          variant="outlined"
          fullWidth
          multiline
          rows="3"
          component={FormikTextField}
        />
        <Label>Poll Answers</Label>
        <FieldArray
          name="content.poll.choices"
          render={(arrayHelpers: any) => (
            <>
              {field.value.length > 0 && field.value.map((each: string, index: number) => (
                <PollAnswerWrapper key={index}>
                  <TextField
                    key={index}
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    label={`Choice number ${index + 1}`}
                    value={each}
                    onChange={(e) => arrayHelpers.replace(index, e.target.value)}
                  />
                  <IconButton onClick={() => {
                    if(field.value.length === 1) {
                      return null;
                    }
                    return arrayHelpers.remove(index);
                  }}>
                    <Delete />
                  </IconButton>
                </PollAnswerWrapper>
              ))}
              {(get(errors, field.name) && submitCount > 0) && <ErrorText>{get(errors, field.name)}</ErrorText>}
              {field.value.length < 4 && <AddAnswerButton type="button" onClick={() => arrayHelpers.push('')}>Add answer</AddAnswerButton>}
            </>
          )}
        />
        <Label>Post-voting Message</Label>
        <StyledField
          name="content.poll.postVotingMessage"
          variant="outlined"
          fullWidth
          component={FormikTextField}
        />
      </>
    );
  }
  if (type === 'S') {
    return (
      <>
        <Label>Media</Label>
        <Field
          name="content.mediaFile"
          component={FormikFileField}
        />
        <MediaDescription>Only file types are suppoted: BMP, PNG, JPG. Maximum file size 25MB.</MediaDescription>
      </>
    )
  }
  if (type === 'B') {
    return (
      <>
        <Label>Media for desktop</Label>
        <Field
          name="content.desktopFile"
          size="short"
          component={FormikFileField}
        />
        <MediaDescription>Size: 728x90px. Only file types are suppoted: BMP, PNG, JPG. Maximum file size 25MB.</MediaDescription>

        <Label>Media for mobile</Label>
        <Field
          name="content.mobileFile"
          size="narrow"
          component={FormikFileField}
        />
        <MediaDescription>Size: 300x250px. Only file types are suppoted: BMP, PNG, JPG. Maximum file size 25MB.</MediaDescription>
      </>
    )
  }
  if (type === 'V') {
    return (
      <>
        <Label>Media</Label>
        <Field
          isVideo
          name="content.mediaFile"
          component={FormikFileField}
        />
        <MediaDescription>Only file types are suppoted: MP4. Maximum file size 25MB.</MediaDescription>
      </>
    );
  }
  return null;
}